import { Download, Search, Upload } from "lucide-react";

const filters = [
  ["all", "全部"],
  ["time", "时间"],
  ["location", "地点"],
  ["solarTerm", "节气"],
  ["style", "风格"],
];

export function Header({ filterType, onFilterType, onImport, search, onSearch }) {
  const isNativeApp = Boolean(window.Capacitor?.isNativePlatform?.());

  return (
    <header className="app-header">
      <a className="brand" href="#archive" aria-label="空の记忆首页">
        <span className="brand-title">空の记忆</span>
        <span className="brand-subtitle">Memories of Sky</span>
      </a>
      <div className="mobile-library-title">我的照片</div>

      <nav className="filter-tabs" aria-label="照片分类维度">
        {filters.map(([value, label]) => (
          <button
            className={filterType === value ? "active" : ""}
            key={value}
            type="button"
            onClick={() => onFilterType(value)}
          >
            {label}
          </button>
        ))}
      </nav>

      <div className="header-actions">
        <label className="search-control">
          <Search aria-hidden="true" size={17} strokeWidth={1.5} />
          <span className="sr-only">搜索照片</span>
          <input value={search} onChange={(event) => onSearch(event.target.value)} placeholder="搜索" />
        </label>
        {!isNativeApp && (
          <a
            className="install-button"
            href="/downloads/sky-memory-android.apk"
            download="sky-memory-android.apk"
            aria-label="下载 Android APK"
          >
            <Download aria-hidden="true" size={16} strokeWidth={1.5} />
            <span>下载 APK</span>
          </a>
        )}
        <button className="primary-button" type="button" onClick={onImport} aria-label="从手机导入照片">
          <Upload aria-hidden="true" size={17} strokeWidth={1.6} />
          <span className="desktop-label">导入照片</span>
          <span className="mobile-label" aria-hidden="true">从手机导入</span>
        </button>
      </div>
    </header>
  );
}
